import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-non-health-authority',
    templateUrl: './non-health-authority.component.html',
    styleUrls: ['./non-health-authority.component.scss'],
    standalone: false
})
export class NonHealthAuthorityComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
  }
  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      productSKU: ['', { validators: [] }],
      trackingNumber: ['', { validators: [] }],
      batchNumber: ['', { validators: [] }],
      companyProductCrossReferenceDi: ['', { validators: [] }],
      submissionChannelForm: this.fb.array([this.addSubmissionChannelForm()])
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
    });
  }

  get submissionChannelForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('submissionChannelForm');
  }

  addSubmissionChannelForm(): FormGroup {

    return this.fb.group({
      email: ['', { validators: [] }],
      phone: [this.fb.array([])]
    });
  }

  patchForms() {

    this.deviceForm.patchValue({

      productSKU: this.displayItemData('Product SKU'),
      trackingNumber: this.displayItemData('Company Device Tracking Number'),
      batchNumber: this.displayItemData('Company Device Batch Number'),
      companyProductCrossReferenceDi: this.displayItemData('Company Product Cross Reference DI')
    });

    this.deviceForm.setControl('submissionChannelForm', this.setSubmissionChannelForm());

  }

  setSubmissionChannelForm(): FormArray {

    const formArray = new FormArray([]);

    let item: any;

    item = this.displayItemData('Applicable Submission Channel');

    if (item && item.length > 0) {
      item.forEach((c, i) => {
        formArray.push(

          this.fb.group({
            channel: c[(this.getMapInnerPathName('Submission Channel'))[0]]
          })
        );
      });
    }

    return formArray;
  }
}
